import { RouteObject, Navigate } from 'react-router-dom';

export const helpdeskRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="/support/tickets/tickets" replace />,
  },
  {
    path: 'tickets',
    element: <Navigate to="/support/tickets/tickets" replace />,
    handle: { crumb: 'Tickets' },
  },
  {
    path: 'kb',
    element: <Navigate to="/support/knowledge/kb-articles" replace />,
    handle: { crumb: 'Knowledge Base' },
  },
];
